import React from 'react';
import { Formik, Form } from 'formik';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  useToast,
} from '@chakra-ui/react';
import FaqApi from 'api/faq';
import { useAuth } from '../../../../auth-context/auth.context';
import SelectField from 'components/formComponents/selectField';
import TextAreaField from 'components/formComponents/textAreaField';
import InputField from 'components/formComponents/inputField.js';
import { FaqValidationSchema } from 'formValidations/faqFormValidations';

const PopModal = (props) => {
  const { user } = useAuth();
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);

  const initialValues = {
    question: '',
    answer: '',
    isActive: 'true',
    displayOrder: 100
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      let response = await FaqApi.Create({
        question: values.question,
        answer: values.answer,
        isActive: values.isActive,
        displayOrder: values.displayOrder,
        language_code: values.language_code
      });
      response = response.data;
      if (response.status_code === 200) {
        toast({
          title: response?.data?.message || 'Successfully Added',
          status: 'success',
          duration: 5000,
          isClosable: true,
          position: 'top',
        });
        onClose();
        props.func();
      } else {
        toast({
          title: response?.data?.message || 'Error Adding',
          status: 'error',
          duration: 5000,
          isClosable: true,
          position: 'top',
        });
      }
    } catch (error) {
      toast({
        title: 'Unable to Add',
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top',
      });
      console.log(error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Button
        variant='lightBrand'
        fontSize='sm'
        fontWeight='500'
        borderRadius='10px'
        boxShadow='lg'
        px='15px'
        py='5px'
        disabled={props.disabled}
        onClick={onOpen}>
        {props.Icon}
      </Button>
      <Modal
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{props.head}</ModalHeader>
          <ModalCloseButton />
          <Formik
            initialValues={initialValues}
            validationSchema={FaqValidationSchema}
            onSubmit={handleSubmit}>
            {({ isSubmitting }) => (
              <Form noValidate>
                <ModalBody pb={6}>
                  <TextAreaField
                    label='Question'
                    name='question'
                    type='text'
                    placeholder='Upto 200 Characters'
                  />
                  <TextAreaField
                    label='Answer'
                    name='answer'
                    type='text'
                    placeholder='Upto 400 Characters'
                    mt={4}
                  />
                  <SelectField
                    label='Status'
                    name='isActive'
                    options={[
                      { value: 'true', label: 'Active' },
                      { value: 'false', label: 'Inactive' },
                    ]}
                    mt={4}
                  />
                  <SelectField
                    label='Language'
                    name='language_code'
                    options={[
                      { value: 'en', label: 'English' },
                      { value: 'kn', label: 'Kannada' },
                    ]}
                    mt={4}
                  />
                  <InputField
                    name='displayOrder'
                    label='Display Order'
                    type='number'
                    placeholder='Enter Display Order'
                    required
                  />
                </ModalBody>
                <ModalFooter>
                  <Button
                    colorScheme='blue'
                    mr={3}
                    type='submit'
                    isLoading={isSubmitting}>
                    Save
                  </Button>
                  <Button onClick={onClose}>Cancel</Button>
                </ModalFooter>
              </Form>
            )}
          </Formik>
        </ModalContent>
      </Modal>
    </>
  );
};

export default PopModal;
